module.exports = __webpack_public_path__ + "static/img/fbec_gzh.3e44928.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/com/fbec_gzh.png
// module id = 8hN+
// module chunks = 27